import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const setVh = () => {
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--screen-100vh', `${vh}px`);
};


const isMobile = window.innerWidth < 840;

function init() {
    // Ejecutar al cargar
    setVh();

    // Y volver a ejecutar en resize/orientación
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);

    toggleMenuBehavior();
    resetScrollAndMenu();
    if (document.body.classList.contains('home')) {
        heroAnimOnFirstScroll();
    }
    if (document.body.classList.contains('single-properties')) {
        projectAccordion();
        openContact();
        handleLocationTimes();
        window.addEventListener('resize', handleLocationTimes);
    }
    if (document.body.classList.contains('page__about')) {
        process();
    }
    if (document.body.classList.contains('post-type-archive-properties')) {
        propertiesMobileActive();
    }
}

window.onload = (event) => {
    console.log('page is fully loaded');
    init();

};

function toggleMenuBehavior() {
    const menuCheckbox = document.getElementById('menu');
    const header = document.querySelector('body');

    if (menuCheckbox && header) {
        menuCheckbox.addEventListener('change', () => {
            header.classList.toggle('menu-open', menuCheckbox.checked);
        });
    }
}


function resetScrollAndMenu() {
    console.log('init')
    // Asegura que el scroll esté al top con un pequeño delay
    window.scrollTo(0, 0)

    document.body.classList.remove("menu-open");
    document.body.classList.remove("overflow-hidden");
    // document.querySelector('.header').classList.remove("menu-open");


    // Desactiva el input #menu si existe y está marcado
    const menuToggle = document.getElementById("menu");
    if (menuToggle && menuToggle.checked) {
        menuToggle.checked = false;
    }
}


// Para volver atrás o adelante desde caché
window.addEventListener("pageshow", (event) => {
    if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
        // Esperamos un poco más para asegurarnos que el navegador permita el scroll
        setTimeout(() => resetScrollAndMenu(), 50);
    }
});

jQuery(function ($) {
    $(document).ready(function () {
        const isMobile = window.innerWidth < 840;
        // Configuración base de sliders
        const defaultSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 840,
                    settings: {
                        centerPadding: '20px',
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        };

        // Función para inicializar cualquier slider y actualizar su contador si existe
        function initSlider(selector, settings = defaultSettings) {
            const $slider = $(selector);

            if ($slider.length) {
                $slider.on('init afterChange', function (event, slick, currentSlide) {
                    let slideIndex = (currentSlide !== undefined ? currentSlide : 0) + 1;
                    let totalSlides = slick.slideCount;

                    // Buscar el contenedor del slider
                    const $galleryContainer = $slider.closest('.gallery');

                    // Solo actualizar el contador si existen los elementos en el contenedor
                    const $countCurrent = $galleryContainer.find('.count-current');
                    const $countTotal = $galleryContainer.find('.count-total');

                    if ($countCurrent.length && $countTotal.length) {
                        $countCurrent.text(slideIndex);
                        $countTotal.text(totalSlides);
                    }
                });

                $slider.slick(settings);
            }
            $('.video-gallery').on('afterChange', function (event, slick, currentSlide) {
                let videos = document.querySelectorAll('.slick-video');
                videos.forEach(video => {
                    if (video.closest('.slick-slide').classList.contains('slick-active')) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            });
        }

        if (document.body.classList.contains('home')) {
            if (isMobile) {
                initSlider('.we');
            }
            initSlider('.process__slider', {
                prevArrow: '<button class="button-slider slide-arrow slick-prev"><svg width="19" height="35" viewBox="0 0 19 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 17.5 35)" stroke="#FFE48D" stroke-width="2"/>\n' +
                    '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 17.5)" stroke="#FFE48D" stroke-width="2"/>\n' +
                    '</svg></button>',
                nextArrow: '<button class="button-slider slide-arrow slick-next"><svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<line x1="1.29289" y1="34.2929" x2="18.7929" y2="16.7929" stroke="#FFE48D" stroke-width="2"/>\n' +
                    '<line x1="18.7929" y1="18.2071" x2="1.29289" y2="0.707107" stroke="#FFE48D" stroke-width="2"/>\n' +
                    '</svg>\n</button>',
                responsive: [
                    {
                        breakpoint: 840,
                        settings: {
                            arrows: false,
                            dots: false,
                        }
                    }
                ]
            });
        }
        if (document.body.classList.contains('single-properties')) {
            if (isMobile) {
                initSlider('.details');
            }
            if (!isMobile) {
                initSlider('.gallery__slider.slider1', {
                    prevArrow: '<button class="button-slider slide-arrow prev-arrow"><svg width="19" height="35" viewBox="0 0 19 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 17.5 35)" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 17.5)" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '</svg></button>',
                    nextArrow: '<button class="button-slider slide-arrow next-arrow"><svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<line x1="1.29289" y1="34.2929" x2="18.7929" y2="16.7929" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '<line x1="18.7929" y1="18.2071" x2="1.29289" y2="0.707107" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '</svg>\n</button>',
                });
                initSlider('.gallery__slider.slider2', {
                    prevArrow: '<button class="button-slider slide-arrow prev-arrow"><svg width="19" height="35" viewBox="0 0 19 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 17.5 35)" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '<line y1="-1" x2="24.7487" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 17.5)" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '</svg></button>',
                    nextArrow: '<button class="button-slider slide-arrow next-arrow"><svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<line x1="1.29289" y1="34.2929" x2="18.7929" y2="16.7929" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '<line x1="18.7929" y1="18.2071" x2="1.29289" y2="0.707107" stroke="#FFE48D" stroke-width="2"/>\n' +
                        '</svg>\n</button>',
                });
            }

        }
        if (document.body.classList.contains('page-about')) {
            if (isMobile) {
                initSlider('.we');
            }
        }
    });
});

function heroAnim() {
    const isMobile = window.innerWidth < 840;

    if (isMobile) {
        gsap.timeline()
            .to(".hero__container--title", {
                duration: 1.2,
                margin: "0.5rem 0",
                ease: "power2.out",
                delay: 1
            })
            .to(".hero__container--img", {
                duration: 2,
                yPercent: -145,
                ease: "power2.out",
                stagger: 1.25,
                onComplete: args => {
                    document.body.style.overflow = 'auto';
                }
            });
    } else {
        const tl = gsap.timeline();

        tl.to([".hero__right .hero__container--title", ".hero__left .hero__container--title"], {
            duration: 1.2,
            y: "-7rem",
            ease: "power2.out",
            delay: 1
        })
        tl.to([".hero__right .hero__container--img", ".hero__left .hero__container--img"], {
            duration: 2.5,
            yPercent: -140,
            ease: "power2.out"
        }, "-=0.5") // sin delay entre títulos y estas imágenes

        tl.to(".hero__center .hero__container--img", {
                duration: 2.5,
                yPercent: -140,
                ease: "power2.out",
                onComplete: args => {
                    document.body.style.overflow = 'auto';
                }
            },
            "-=1.8" // empieza mientras las otras están terminando (ajustable)
        );
    }
}

function heroAnimOnFirstScroll() {
    let hasPlayed = false;
    const isMobile = window.innerWidth < 840;

    function playAnimation() {
        if (hasPlayed) return;
        hasPlayed = true;

        window.removeEventListener('wheel', playAnimation);
        window.removeEventListener('touchstart', playAnimation);

        if (isMobile) {
            gsap.timeline()
                .to(".hero__container--title", {
                    duration: 1.2,
                    margin: "0.5rem 0",
                    ease: "power2.out"
                })
                .to(".hero__container--img", {
                    duration: 2,
                    yPercent: -145,
                    ease: "power2.out",
                    stagger: 1.25,
                    onComplete: () => {
                        document.body.style.overflow = 'auto';
                    }
                });
        } else {
            const tl = gsap.timeline();

            tl.to([".hero__right .hero__container--title", ".hero__left .hero__container--title"], {
                duration: 1.2,
                y: "-7rem",
                ease: "power2.out"
            })
                .to([".hero__right .hero__container--img", ".hero__left .hero__container--img"], {
                    duration: 2.5,
                    yPercent: -140,
                    ease: "power2.out"
                }, "-=0.5")
                .to(".hero__center .hero__container--img", {
                    duration: 2.5,
                    yPercent: -140,
                    ease: "power2.out",
                    onComplete: () => {
                        document.body.style.overflow = 'auto';
                    }
                }, "-=1.8");
        }
    }

    // Al cargar, bloqueamos scroll
    document.body.style.overflow = 'hidden';

    // Escuchamos el primer intento de scroll (wheel en desktop, touch en mobile)
    window.addEventListener('wheel', playAnimation, {once: true});
    window.addEventListener('touchstart', playAnimation, {once: true});
}


function processOld() {
    const steps = ['architectural-design', 'construction', 'handover', 'after-sales'];
    const process = document.querySelector('.process');
    const isMobile = window.innerWidth < 840;
    gsap.timeline({
        scrollTrigger: {
            trigger: process,
            start: isMobile ? 'top top' : 'bottom bottom',
            end: '+=800vh',
            scrub: true,
            pin: true,
            anticipatePin: 1,
            snap: {
                snapTo: 1 / steps.length,
                duration: 0.4,
                ease: 'power1.inOut'
            },
            onUpdate: self => {
                const progress = self.progress;
                const stepIndex = Math.floor(progress * steps.length);

                // Limpia todas las clases
                process.classList.remove('site-selection', ...steps);

                if (progress === 0) {
                    // En el inicio, antes del primer paso
                    process.classList.add('site-selection');
                } else if (stepIndex >= 0 && stepIndex < steps.length) {
                    // Añadir paso correspondiente
                    process.classList.add(steps[stepIndex]);
                }
            }
        }
    });
}

function process() {
    const steps = ['architectural-design', 'construction', 'handover', 'after-sales'];
    const process = document.querySelector('.process');
    const isMobile = window.innerWidth < 840;

    gsap.timeline({
        scrollTrigger: {
            trigger: process,
            start: isMobile ? 'top top' : 'bottom bottom',
            end: '+=800vh',
            scrub: true,
            pin: true,
            anticipatePin: 1,
            snap: {
                snapTo: 1 / steps.length,
                duration: 0.4,
                ease: 'power1.inOut'
            },

            onUpdate: self => {
                const progress = self.progress;
                const stepIndex = Math.floor(progress * steps.length);

                // Al principio
                if (progress === 0) {
                    process.classList.remove(...steps);
                    process.classList.add('site-selection');
                }

                // Durante scroll normal (evitamos modificar si salimos del trigger)
                if (progress > 0 && progress < 1) {
                    process.classList.remove('site-selection', ...steps);
                    if (stepIndex >= 0 && stepIndex < steps.length) {
                        process.classList.add(steps[stepIndex]);
                    }
                }
            },

            onLeave: () => {
                // Al salir hacia abajo, fijamos sólo la clase final
                process.classList.remove('site-selection', ...steps);
                process.classList.add('after-sales');
            },

            onEnterBack: () => {
                // Al volver hacia arriba, mostramos .after-sales como punto de entrada
                process.classList.remove('site-selection', ...steps);
                process.classList.add('after-sales');
            }
        }
    });
}

function aboutGallerys() {

// 3. Secuencia de entrada para las imágenes secundarias
    const images = gsap.utils.toArray('.is-secondary');

    // 2. Timeline general con ScrollTrigger y pin
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.gallery',
            start: 'top top',
            end: `+=${window.innerHeight * 0.4 * images.length}`,
            scrub: true,
            pin: true,
            anticipatePin: 1,
            markers: false
        }
    });

// 3. Para cada imagen, se anima su entrada al centro
    images.forEach((img, i) => {
        tl.to(img, {
            y: '-50%',
            duration: 0.5
        }, i); // cada imagen entra en su paso
    });

}

function aboutGallery() {

// Set inicial: las secundarias fuera de la pantalla
    gsap.set('.is-secondary', {y: '50vh', opacity: 1});

    const secondary = gsap.utils.toArray('.is-secondary');
    const gallery = document.querySelector('.gallery');

// Timeline completo basado en el scroll de .gallery
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: gallery,
            start: 'top top',
            end: `+=${window.innerHeight * 0.6 * secondary.length}`,
            scrub: true,
            markers: false
        }
    });

// Añadimos animaciones para cada .is-secondary
    secondary.forEach((el, i) => {
        tl.to(el, {
            y: '-52%',
            ease: 'none',
            duration: 0.5
        }, i); // cada uno entra progresivamente
    });

}

function projectAccordion() {
    // Abre solo el primer .data__item
    const dataSection = document.querySelector('.data');
    if (dataSection) {
        const items = dataSection.querySelectorAll('.data__item');
        items.forEach((item, index) => {
            const content = item.querySelector('.data__content');
            const button = item.querySelector('.data__header--accordion');
            const arrow = button?.querySelector('.icon--arrow');
            const close = button?.querySelector('.icon--close');

            if (index === 0) {
                // Mostrar el primero
                content.removeAttribute('hidden');
                button.setAttribute('aria-expanded', 'true');
                if (arrow) arrow.style.display = 'none';
                if (close) close.style.display = 'inline';
            } else {
                // Asegurar que el resto están cerrados
                content.setAttribute('hidden', '');
                button.setAttribute('aria-expanded', 'false');
                if (arrow) arrow.style.display = 'inline';
                if (close) close.style.display = 'none';
            }
        });
    }

    // Activar el toggle
    document.querySelectorAll('.data__header--accordion').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.closest('.data__item');
            const content = item.querySelector('.data__content');
            const isOpen = !content.hasAttribute('hidden');

            // Toggle el contenido
            if (isOpen) {
                content.setAttribute('hidden', '');
                button.setAttribute('aria-expanded', 'false');
            } else {
                content.removeAttribute('hidden');
                button.setAttribute('aria-expanded', 'true');
            }

            // Toggle íconos
            const arrow = button.querySelector('.icon--arrow');
            const close = button.querySelector('.icon--close');
            if (arrow && close) {
                arrow.style.display = isOpen ? 'inline' : 'none';
                close.style.display = isOpen ? 'none' : 'inline';
            }
        });
    });
}

function openContact() {
    document.querySelectorAll('.data__header--btn').forEach(btn => {
        btn.addEventListener('click', () => {
            document.body.classList.add('popup-open');
        });
    });
    document.querySelectorAll('.popup__close').forEach(btn => {
        btn.addEventListener('click', () => {
            document.body.classList.remove('popup-open');
        });
    });
}

function propertiesMobileActive() {
    const isMobile = window.innerWidth < 840;
    if (isMobile) {
        document.querySelectorAll('.content__menu--link').forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top center",
                end: "bottom center",
                toggleClass: {
                    targets: el,
                    className: "active"
                },
                toggleActions: "play reverse play reverse",
                markers: false, // ponlo en true si quieres ver los puntos
                onEnter: () => el.classList.add("active"),
                onLeave: () => el.classList.remove("active"),
                onEnterBack: () => el.classList.add("active"),
                onLeaveBack: () => el.classList.remove("active"),
            });
        });
    }
}


const timeTranslations = {
    'minutos': 'min.',
    'minutes': 'min.',
    'Minuten': 'Min.' // Mantiene mayúscula para alemán
};

function abbreviateTime(text) {
    // Dividir el texto en palabras
    const words = text.trim().split(/\s+/);
    if (words.length === 0) return text;

    const lastWord = words[words.length - 1];

    // Primero intentar con las traducciones conocidas
    const abbreviation = timeTranslations[lastWord];
    console.log(abbreviation);
    if (abbreviation) {
        words[words.length - 1] = abbreviation;
    } else {
        // Si no es una traducción conocida, abreviar genéricamente
        words[words.length - 1] = lastWord.substring(0, 3) + '.';
    }

    return words.join(' ');
}

function handleLocationTimes() {
    const timeElements = document.querySelectorAll('.location__list--info');
    const isMobile = window.innerWidth < 768;
    console.log(timeElements);
    timeElements.forEach(element => {
        const originalText = element.getAttribute('data-original-text') || element.textContent;

        if (!element.getAttribute('data-original-text')) {
            element.setAttribute('data-original-text', originalText);
        }

        element.textContent = isMobile ? abbreviateTime(originalText) : originalText;
    });
}

